import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { HtmlEditorService, ImageService, ImageSettingsModel, InsertHtml, LinkService, NodeSelection, QuickToolbarService, RichTextEditorComponent, RichTextEditorModule, ToolbarService } from '@syncfusion/ej2-angular-richtexteditor';
import { ExportInterfaceConfigurationDetailsFilePlaceholderDTO } from '../../models/models.swagger.generated';
import { GridConstantsFactory } from '../syncfusion/grid-constants-factory';
import { ExportConfigurationMasterDataServiceService } from 'src/app/domain/export-configuration/export-configuration-master-data.service';
import { DropDownList, DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

import { AppErrorMessagesComponent } from '../../error-messages/app-error-messages.component';
import { OutputEmailAccountsService } from 'src/app/domain/export-configuration/activation-email-templates/output-email-accounts.service';

@Component({
    selector: 'app-email-form',
    templateUrl: './email-form.component.html',
    styleUrls: ['./email-form.component.scss'],
    imports: [TranslateModule, AppErrorMessagesComponent, ReactiveFormsModule, RichTextEditorModule, DropDownListModule],
    providers: [ToolbarService, LinkService, ImageService, HtmlEditorService, QuickToolbarService]
})
export class EmailFormComponent implements OnInit, AfterViewInit {
  @Input()
  public emailForm: UntypedFormGroup;

  @Input()
  public showLoadFromTemplateButton: boolean = true;

  @Input()
  public showPlaceholders: boolean = false;

  @Input()
  public showOutputEmailAccountField: boolean = true;

  @Output()
  public loadFromTemplateClicked: EventEmitter<void> = new EventEmitter();

  @ViewChild('textHTML')
  private richTextEditor: RichTextEditorComponent;

  public insertImageSettings: ImageSettingsModel = { saveFormat: 'Base64' };
  public filterSettings = GridConstantsFactory.createStandardFilterSettings();
  public data: ExportInterfaceConfigurationDetailsFilePlaceholderDTO[];

  public selection: NodeSelection = new NodeSelection();
  public range: Range;
  public saveSelection: NodeSelection;

  public tools: object;

  public outputEmailAccountFields = { text: 'accountName', value: 'id' };;

  public get outputEmailAccounts() {
    return this.outEmailAccountsService.outputEmailAccounts;
  }


  constructor(private masterDataServiceService: ExportConfigurationMasterDataServiceService,
    private translateService: TranslateService,
    private outEmailAccountsService: OutputEmailAccountsService
  ) { }


  public onLoadTemplateClicked() {
    this.loadFromTemplateClicked.emit();
  }

  ngOnInit() {
    if (this.showPlaceholders) {
      this.tools = {
        items: ['Bold', 'Italic', 'Underline', 'StrikeThrough', 'ClearFormat', '|', 'FontSize', 'FontColor', 'BackgroundColor', 'Formats', 'Alignments', 'NumberFormatList',
          'BulletFormatList', '|', 'CreateLink', 'Image',
          {
            tooltipText: this.translateService.instant("i18n.base.shared.email-form.form-fields.placeholders-tooltip"),
            template: '<input type="text" id="dropdown" />'
          }, '|', 'SourceCode', '|', 'Undo', 'Redo'
        ]
      };

    }
    else {
      this.tools = {
        items: ['Bold', 'Italic', 'Underline', 'StrikeThrough', 'ClearFormat', '|', 'FontSize', 'FontColor', 'BackgroundColor', 'Formats', 'Alignments', 'NumberFormatList',
          'BulletFormatList', '|', 'CreateLink', 'Image', '|', 'SourceCode', '|', 'Undo', 'Redo'
        ]
      }
    }
  }

  ngAfterViewInit(): void {
    if (this.showPlaceholders) {
      this.initializeData();
    }
  }

  onActionComplete(args: any): void {
    //Fix for closing source code view
    if (args.requestType === 'Preview') {
      const sourceViewElement = document.getElementById('textHTML_source-view');
      if (sourceViewElement) {
        sourceViewElement.remove();
      }
    }
  }

  private initializeData(): void {
    if (!this.data) {
      this.masterDataServiceService.getMasterDataForFileName().subscribe(data => {
        this.data = data.possibleEmailPlaceholders;
        this.createPlaceHolderDropdown();
      });
    }
    else if (this.showPlaceholders) {
      this.createPlaceHolderDropdown();
    }
  }

  private createPlaceHolderDropdown(): void {
    let proxy = this.richTextEditor;
    let dropdown: DropDownList = new DropDownList({
      dataSource: this.data.map(value => value.placeholder),
      placeholder: this.translateService.instant("i18n.base.shared.email-form.form-fields.placeholders-title"),
      change: (args: any) => {
        proxy.focusIn();
        InsertHtml.Insert(document, document.createTextNode(args.value), proxy.inputElement as Element);
      }
    });
    dropdown.appendTo('#dropdown');
  }


}
